import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container d-flex w-100 mx-0 px-0 flex-grow-1" };
const _hoisted_2 = { class: "row mx-0 px-0 my-2 flex-grow-1" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2" }, null, -1);
const _hoisted_4 = { class: "d-flex" };
const _hoisted_5 = { class: "m-2 p-0 overflow-hidden" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_scroll_box = _resolveComponent("g-scroll-box");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, "path: " + _toDisplayString(_ctx.window.path), 1),
            _hoisted_3,
            _createVNode(_component_g_form, null, {
                default: _withCtx(() => [
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "navigation.mode",
                        "data-mode": "model",
                        label: "Fenster: Modus"
                    }, null, 8, ["data-object"]),
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "navigation.location",
                        "data-mode": "model",
                        label: "Entity: Location"
                    }, null, 8, ["data-object"]),
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "navigation.size",
                        "data-mode": "model",
                        label: "Entity: Size"
                    }, null, 8, ["data-object"]),
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "entity.name",
                        "data-mode": "model",
                        label: "Entity: Name"
                    }, null, 8, ["data-object"]),
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "entity.mode",
                        "data-mode": "model",
                        label: "Entity: Modus"
                    }, null, 8, ["data-object"]),
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "entity.id",
                        "data-mode": "model",
                        label: "Entity: ID"
                    }, null, 8, ["data-object"]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.update && _ctx.update(...args)), ["stop", "prevent"]))
                        }, "Aktualisieren"),
                        _createElementVNode("button", {
                            class: "btn btn-outline-danger ms-2",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.close && _ctx.close(...args)), ["stop", "prevent"]))
                        }, "Schließen")
                    ])
                ]),
                _: 1
            }),
            _createVNode(_component_g_scroll_box, null, {
                default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_5, _toDisplayString(_ctx.$data), 1)
                ]),
                _: 1
            })
        ])
    ]));
}
